import { Component } from 'react';

import { FormattedMessage } from 'react-intl';

import styles from './ManualCompany.module.css';
import { TextInput } from '../../../../forms/formField/Input';

export class ManualCompany extends Component {
    onCompanyNameChange = (value) => {
        this.props.companyName.input.onChange(value);
        this.props.onChangePrompt(value);
    };

    onCompanyNumberChange = (value) => {
        this.props.companyNumber.input.onChange(value);
        this.props.onChangePrompt(value);
    };

    render() {
        const { companyName, companyNumber } = this.props;

        const companyNameInput = {
            ...companyName,
            input: {
                ...companyName.input,
                onChange: this.onCompanyNameChange
            },
            id: 'companyName',
            disabled: true
        };

        const companyNumberInput = {
            ...companyNumber,
            input: {
                ...companyNumber.input,
                onChange: this.onCompanyNumberChange
            },
            id: 'companyNumber',
            disabled: true
        };

        return (
            <div className={styles.ManualCompany}>
                <div className={styles.registeredName}>
                    <label htmlFor="companyName">
                        <FormattedMessage
                            id="_.manualCompany.registered_name"
                            defaultMessage="Registered name"
                        />
                    </label>
                    <TextInput {...companyNameInput} />
                </div>
                <div className={styles.registeredNumber}>
                    <label htmlFor="companyNumber">
                        <FormattedMessage
                            id="_.manualCompany.registered_number"
                            defaultMessage="Registered number"
                        />
                    </label>
                    <TextInput {...companyNumberInput} />
                </div>
            </div>
        );
    }
}
